import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {take} from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class LayoutService {
  private mainOverflowVisible = new BehaviorSubject<boolean>(false);
  readonly isMainOverflowVisible$: Observable<boolean> = this.mainOverflowVisible.asObservable();

  private navState$ = new BehaviorSubject<boolean>(false);
  private leftMenuOpened$ = new BehaviorSubject<boolean>(false);

  setOverflowToVisible(isActive: boolean) {
    this.mainOverflowVisible.next(isActive);
  }

  setNavbarState(state: boolean): void {
    this.navState$.next(state);
  }

  toggleNavbarState(): void {
    this.navState$.pipe(take(1)).subscribe(s => this.navState$.next(!s));
  }

  getNavbarState(): Observable<boolean> {
    return this.navState$.asObservable();
  }

  setLeftMenuOpenedState(state: boolean): void {
    this.leftMenuOpened$.next(state);
  }

  getLeftMenuIfOpenedState(): Observable<boolean> {
    return this.leftMenuOpened$.asObservable();
  }
}
